<template>
  <div>
    <div class="deduction-list">
      <div class="loading-deduction" v-show="loading">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
        <span>LOADING DEDUCTIONS...</span>
      </div>

      <div v-show="!loading">
        <div class="add-new">
          <a class="button cta small" href="javascript:;" @click="openForm(null)">
            <i class="fa fa-plus"></i>
            <span>ADD NEW DEDUCTION</span>
          </a>
        </div>

        <table v-if="!isMobile">
          <thead>
            <tr class="table-header">
              <th>ID</th>
              <th>NAME</th>
              <th>DESCRIPTION</th>
              <th>AMOUNT</th>
              <th>START DATE</th>
              <th>END DATE</th>
              <th>DEDUCTION DETAILS</th>
              <th>TNC</th>
              <th>TCP</th>
              <th>PSC</th>
              <th>ENABLED</th>
              <th>CONTROLS</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" v-show="items.length <= 0">
              <td class="empty-row" colspan="10">
                There are no deductions yet.<br/>Click on the button at the top-left to create one.
              </td>
            </tr>
            <tr class="table-row" v-for="item in items" v-show="items.length > 0">
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>${{ item.amount.toFixed(2) }}</td>
              <td>{{ item.effectiveStart.format('MM/DD/YYYY') }}</td>
              <td>{{ item.effectiveEnd.format('MM/DD/YYYY') }}</td>
              <td>{{ getDeductionDetails(item) }}</td>
              <td>
                <i class="fa fa-check-circle fa-lg" v-show="item.applyTNC"></i>
                <i class="fa fa-times-circle fa-lg" v-show="!item.applyTNC"></i>
              </td>
              <td>
                <i class="fa fa-check-circle fa-lg" v-show="item.applyTCP"></i>
                <i class="fa fa-times-circle fa-lg" v-show="!item.applyTCP"></i>
              </td>
              <td>
                <i class="fa fa-check-circle fa-lg" v-show="item.applyPSC"></i>
                <i class="fa fa-times-circle fa-lg" v-show="!item.applyPSC"></i>
              </td>
              <td>
                <span v-show="item.enabled" class="enabled">YES</span>
                <span v-show="!item.enabled" class="enabled no">NO</span>
              </td>
              <td>
                <a class="button cta xsmall" href="javascript:;" @click="openForm(item)">EDIT</a>
                <a class="button cta xsmall warning" href="javascript:;" @click="showDelete(item)">DELETE</a>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="cards" v-else>
          <div class="card" v-show="items.length <= 0">There are no deductions yet.<br/>Click on the button at the top-left to create one.</div>
          <div class="card" v-for="item in items" v-show="items.length > 0" :key="item.id">
            <div class="internal-card">
              <div class="card-header">
                <div class="id">
                  <div class="label">ID: </div>
                  <div class="value">{{item.id}}</div>
                </div>
                <div class="enabled">
                  <span v-show="item.enabled" class="yes">Enabled</span>
                  <span v-show="!item.enabled" class="no">Disabled</span>
                </div>
              </div>
  
              <div class="title block">
                <span class="label">Name: </span>
                <div class="value">{{item.name}}</div>
              </div>
  
              <div class="title block">
                <div class="label">Description: </div>
                <div class="value">{{item.description}}</div>
              </div>
  
              <div class="title">
                <div class="label">Amount: </div>
                <div class="value">${{ item.amount.toFixed(2) }}</div>
              </div>
  
              <div class="title">
                <div class="label">Start Date: </div>
                <div class="value">{{ item.effectiveStart.format('MM/DD/YYYY') }}</div>
              </div>
  
              <div class="title">
                <div class="label">End Date: </div>
                <div class="value">{{ item.effectiveEnd.format('MM/DD/YYYY') }}</div>
              </div>
  
              <div class="title block">
                <div class="label">DEDUCTION DETAILS: </div>
                <div class="value">{{ getDeductionDetails(item) }}</div>
              </div>
              <div class="title checks">
                <div class="label">TNC: 
                  <i class="fa fa-check-circle fa-lg" v-show="item.applyTNC"></i>
                  <i class="fa fa-times-circle fa-lg" v-show="!item.applyTNC"></i>
                </div>
                <div class="label">TCP: 
                  <i class="fa fa-check-circle fa-lg" v-show="item.applyTCP"></i>
                  <i class="fa fa-times-circle fa-lg" v-show="!item.applyTCP"></i>
                </div>
                <div class="label">PSC: 
                  <i class="fa fa-check-circle fa-lg" v-show="item.applyPSC"></i>
                  <i class="fa fa-times-circle fa-lg" v-show="!item.applyPSC"></i>
                </div>
              </div>

            </div>

            <div class="actions">
              <a class="button cta small" href="javascript:;" @click="openForm(item)">EDIT</a>
              <a class="button cta small warning" href="javascript:;" @click="showDelete(item)">DELETE</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'deduction-list',
  props: ['isMobile'],
  computed: {
    loading () { return this.$store.state.providerDeductions.deductionList.loading },
    items () { return this.$store.state.providerDeductions.deductionList.items },
    reload () { return this.$store.state.providerDeductions.deductionList.reload }
  },
  methods: {
    openForm (item) {
      this.$store.commit('providerDeductions/setDeductionFormId', item === null ? null : item.id)
      this.$store.commit('providerDeductions/setDeductionFormName', item === null ? '' : item.name)
      this.$store.commit('providerDeductions/setDeductionFormDescription', item === null ? '' : item.description)
      this.$store.commit('providerDeductions/setDeductionFormAmount', item === null ? 0 : item.amount)
      this.$store.commit('providerDeductions/setDeductionFormEffectiveStart', item === null ? null : item.effectiveStart)
      this.$store.commit('providerDeductions/setDeductionFormEffectiveEnd', item === null ? null : item.effectiveEnd)
      this.$store.commit('providerDeductions/setDeductionFormEnabled', item === null ? false : (item.enabled ? true : false))
      this.$store.commit('providerDeductions/setDeductionFormApplyTNC', item === null ? false : item.applyTNC)
      this.$store.commit('providerDeductions/setDeductionFormApplyTCP', item === null ? false : item.applyTCP)
      this.$store.commit('providerDeductions/setDeductionFormApplyPSC', item === null ? false : item.applyPSC)
      this.$store.commit('providerDeductions/setDeductionFormSelectedInterval', item === null ? 'weekly' : item.interval)
      this.$store.commit('providerDeductions/setDeductionFormSelectedWeeklyAnchor', item === null ? 'monday' : (item.weeklyAnchor === null ? 'monday' : item.weeklyAnchor))
      this.$store.commit('providerDeductions/setDeductionFormSelectedMonthlyAnchor', item === null ? 1 : (item.monthlyAnchor === null ? 1 : item.monthlyAnchor))
      this.$store.commit('providerDeductions/setDeductionFormShow', true)
    },
    getDeductionDetails (item) {
      let self = this
      if (item.interval === 'weekly') {
        return 'Deducted weekly every ' + self.ucFirst(item.weeklyAnchor) + '.'
      }
      return 'Deducted every ' + self.daySuffix(item.monthlyAnchor) + ' of the month.'
    },
    ucFirst (string) { return string.charAt(0).toUpperCase() + string.slice(1) },
    daySuffix (i) {
      let j = i % 10
      let k = i % 100
      if (j == 1 && k != 11) {
          return i + "st"
      }
      if (j == 2 && k != 12) {
          return i + "nd"
      }
      if (j == 3 && k != 13) {
          return i + "rd"
      }
      return i + "th"
    },
    formatItems (items) {
      let results = []
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        let start = moment(item.effectiveStart.substring(0, 10) + ' ' + item.effectiveStart.substring(11, 19), 'YYYY-MM-DD HH:mm:ss')
        let end = moment(item.effectiveEnd.substring(0, 10) + ' ' + item.effectiveEnd.substring(11, 19), 'YYYY-MM-DD HH:mm:ss')
        item.effectiveStart = start
        item.effectiveEnd = end
        results.push(item)
      }
      return results
    },
    loadItems () {
      let self = this
      self.$store.commit('providerDeductions/setDeductionListLoading', true)
      self.$sdk.get('/admin/providerdeduction', {
        token: self.$store.state.session.sessionToken,
        deleted: 0,
        order: 'created',
        orderAsc: 0
      }, r => {
        self.$store.commit('providerDeductions/setDeductionListLoading', false)
        if (r.error) {
          self.$store.commit('providerDeductions/setDeductionListItems', [])
          return
        }
        self.$store.commit('providerDeductions/setDeductionListItems', self.formatItems(r.list))
        self.$store.commit('providerDeductions/setDeductionListReload', false)
      })
    },
    showDelete (item) {
      this.$store.commit('providerDeductions/setDeductionDeleteShow', true)
      this.$store.commit('providerDeductions/setDeductionDeleteItem', item)
    }
  },
  watch: {
    reload (value) {
      if (!value) {
        return
      }
      this.loadItems()
    }
  },
  mounted () { this.loadItems() }
}
</script>

<style lang="scss" scoped>
.add-new {
  margin: 20px 0;
}
.deduction-list {
  position: relative;
  padding: 0 20px;
}
table{
  border-collapse: collapse;
  width: 100%;
  & thead{
  }
}
.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;
  & th{
    padding: 5px;
  }
}
.table-row{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);
  & td{
    padding: 10px 5px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;
    & > .fa-check-circle { color: #26D97A; }
    & > .fa-times-circle { color: #F25E0D; }
  }
  & .empty-row {
    font-size: 16px;
    padding: 20px;
  }
}
.enabled {
  display: inline-block;
  background-color: #26D97A;
  color: #fff;
  font-weight: 700;
  padding: 5px;
  border-radius: 5px;
  &.no { background-color: #F25E0D; }
}
.loading-deduction {
  text-align: center;
  color: #777;
  margin-top: 80px;
  & > * {
    display: block;
  }
  & > span {
    font-size: 20px;
    font-weight: 700;
    margin-top: 20px;
  }
}
@media only screen and (max-width: 430px) {
  .add-new {
    text-align: center;
  }
  .cards {
    margin: 0 auto;
    margin-top: 20px;
    .result-stat {
      width: 100%;
    }
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      .internal-card {
        padding: 8px;
      }
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .id {
          display: flex;
        }
        .enabled {
          padding: 2px;
          font-size: 13px;
          background-color: transparent;
          .yes {
            background-color: #26D97A;
            padding: 2px 5px;
            border-radius: 5px;
          }
          .no {
            background-color: #ccc;
            padding: 2px 5px;
            border-radius: 5px;
          }
        }
      }
      .title {
        display: flex;
        align-items: center;
        margin-bottom: 3px;
        &.checks {
          margin-top: 8px;
        }
        &.block {
          display: block;
        }
      }
      .actions {
        width: 100%;
        background: #f3f3f3;
        border-top: 1px solid #ccc;
        padding: 15px 10px;
        text-align: center;
        margin-top: 15px;
      }
      .label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
        i {
          font-size: 16px;
        }
        & > .fa-check-circle { color: #26D97A; }
        & > .fa-times-circle { color: #F25E0D; }
      }
      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ProviderDeductions/DeductionList.vue